/**
 * V4-ZERNIO-INBOX-BADGE 2026-05-28 — hook qui poll le compteur de commentaires
 * non répondus pour un space. Sert à afficher un badge rouge sur l'icône Engagement
 * du sidebar quand des commentaires sont en attente.
 */
import { useEffect, useRef, useState } from 'react';
import { zernioCommentsService } from '../services/zernioCommentsService';
import { Logger } from '../utils/logger';

const POLL_INTERVAL_MS = 60_000; // 60s — léger pour l'API + frais pour l'UX

export function useUnrepliedCount(spaceId: string | null | undefined): number {
  const [count, setCount] = useState(0);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    if (!spaceId) {
      setCount(0);
      return;
    }

    let timer: ReturnType<typeof setInterval> | null = null;

    const fetchCount = async () => {
      try {
        const c = await zernioCommentsService.countUnreplied(spaceId);
        if (isMountedRef.current) setCount(c);
      } catch (e) {
        Logger.debug('[useUnrepliedCount] fetch failed (silent)', {
          spaceId,
          error: e instanceof Error ? e.message : 'unknown',
        });
        // Silent — pas de toast spam si l'endpoint flaque
      }
    };

    void fetchCount();
    timer = setInterval(fetchCount, POLL_INTERVAL_MS);

    return () => {
      isMountedRef.current = false;
      if (timer) clearInterval(timer);
    };
  }, [spaceId]);

  return count;
}
